module.exports = __webpack_public_path__ + "img/up-icon.e9d0c786.svg";